import { useState, useRef, useEffect } from 'react'
import CloseBubbleIcon from '../../../assets/svgs/CloseBubble'
import style from '../register/Register.module.css'
import ErrorIcon from '../../../assets/svgs/Error'
import axios from 'axios'
import checkPasswordValidation from '../../../utils/PasswordValidation'
import ShowPassIcon from '../../../assets/svgs/ShowPass'

const apiUrl = process.env.REACT_APP_API_URL

const ResetPassword = ({ handleAuth, setOpenAuth }) => {
  const [error, setError] = useState(false)
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  })
  const [passwordValidationMessages, setPasswordValidationMessages] = useState({
    minLength: '',
    hasNumber: '',
    hasSpecialCharacter: '',
  })
  const [
    confrimPasswordValidationMessages,
    setConfirmPasswordValidationMessages,
  ] = useState({
    minLength: '',
    hasNumber: '',
    hasSpecialCharacter: '',
  })
  const [isPasswordFocused, setIsPasswordFocused] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const passwordRef = useRef(null)
  const confirmPasswordRef = useRef(null)

  const userEmail = localStorage.getItem('forgotPasswordEmail')

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
    setError((prevError) => {
      const newError = { ...prevError }
      delete newError[name]
      return newError
    })
    if (name === 'password') {
      const passwordValidationMessages = checkPasswordValidation(value)
      setPasswordValidationMessages(passwordValidationMessages)
    }

    setIsPasswordFocused(name === 'password' && value !== '')
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (passwordRef.current && !passwordRef.current.contains(event.target)) {
        setIsPasswordFocused(false)
      }
    }

    document.addEventListener('click', handleOutsideClick)

    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [])

  const handleSubmit = async () => {
    let hasError = false
    const requiredFields = ['password', 'confirmPassword', 'resetPasswordCode']

    const errors = {}

    requiredFields.forEach((fieldName) => {
      if (!formData[fieldName]) {
        errors[fieldName] = 'Please fill out all the fields'
        hasError = true
      }
    })

    if (formData['password'] && formData['confirmPassword']) {
      if (formData['password'] !== formData['confirmPassword']) {

        errors['confirmPassword'] = 'Passwords do not match'
        setError(errors)
        return
      }
      const passwordValidationResult = checkPasswordValidation(
        formData['password']
      )
      const confirmPasswordValidationResult = checkPasswordValidation(
        formData['confirmPassword']
      )
      if (
        passwordValidationResult.hasError ||
        confirmPasswordValidationResult.hasError
      ) {
        errors['password'] = 'Password does not meet requirements'
        errors['confirmPassword'] = 'Password does not meet requirements'
        setError(errors)
        return
      }
    }

    if (hasError) {
      setError(errors)
      return
    }

    try {
      await axios.post(`${apiUrl}/auth/resetpassword`, {
        email: userEmail,
        password: formData['password'],
        resetCode: formData['resetPasswordCode'],
      })

      setOpenAuth('login')

      localStorage.removeItem('forgotPasswordEmail')
    } catch (err) {
      setError({ ...error, resetPasswordCode: err.response.data.error })
      return
    }
  }
  return (
    <div className={style.mainContainer}>
      <div className={style.container}>
        <div className={style.closeBubble} onClick={handleAuth}>
          <CloseBubbleIcon />
        </div>
        <div className={style.textBox}>
          <p className={style.title}>Forgot password ?</p>
          <p className={style.subTitle}>
            Make new password and enter Reset Password Security code which you
            have to get on <u>{userEmail}</u>
          </p>
        </div>
        <div className={style.form}>
          <div className={style.inputContainerSub}>
            {error && error.password !== undefined ? (
              <div className={style.errorIconContainer}>
                <ErrorIcon />
              </div>
            ) : null}

            <input
              ref={passwordRef}
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className={
                error.password ? style.inputFieldError : style.inputField
              }
              placeholder="Password"
            />

            <div
              onClick={() => setShowPassword(!showPassword)}
              className={style.showPassword}
            >
              <ShowPassIcon show={showPassword ? true : false} />
            </div>

            <div
              className={`${style.passwordCheck} ${isPasswordFocused ? style.showPasswordCheck : ''
                }`}
            >
              {passwordValidationMessages.minLength}
              {passwordValidationMessages.hasNumber}
              {passwordValidationMessages.hasSpecialCharacter}
            </div>

            <p className={style.errorMessage}>{error.password}</p>
          </div>
          <div className={style.inputContainerSub}>
            {error && error.confirmPassword !== undefined ? (
              <div className={style.errorIconContainer}>
                <ErrorIcon />
              </div>
            ) : null}

            <input
              ref={confirmPasswordRef}
              type={showConfirmPassword ? 'text' : 'password'}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              className={
                error.confirmPassword ? style.inputFieldError : style.inputField
              }
              placeholder="Confirm password"
            />

            <div
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className={style.showPassword}
            >
              <ShowPassIcon show={showConfirmPassword ? true : false} />
            </div>

            <p className={style.errorMessage}>{error.confirmPassword}</p>
          </div>
          <div className={style.inputContainerSub}>
            {error && error.resetPasswordCode !== undefined ? (
              <div className={style.errorIconContainer}>
                <ErrorIcon />
              </div>
            ) : null}

            <input
              type="text"
              name="resetPasswordCode"
              value={formData.resetPasswordCode}
              onChange={handleInputChange}
              className={
                error.resetPasswordCode
                  ? style.inputFieldError
                  : style.inputField
              }
              placeholder="Reset Password Code"
            />

            <p className={style.errorMessage}>{error.resetPasswordCode}</p>
          </div>
          <button className={style.button} onClick={handleSubmit}>
            Continue
          </button>
          <div className={style.divider}>
            <div className={style.hr}></div>
            <p className={style.dividerText}> Or</p>
          </div>
          <button
            type="button"
            className={style.mobileButton}
            onClick={handleAuth}
          >
            Cancel{' '}
          </button>
        </div>
      </div>
    </div>
  )
}
export default ResetPassword
